import { render, staticRenderFns } from "./AuthenPage.vue?vue&type=template&id=20be4e39&scoped=true&"
import script from "./AuthenPage.vue?vue&type=script&lang=js&"
export * from "./AuthenPage.vue?vue&type=script&lang=js&"
import style0 from "./AuthenPage.vue?vue&type=style&index=0&id=20be4e39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be4e39",
  null
  
)

export default component.exports